/**
 * Match (Element Matching) Element
 */

import type { ElementDefinition } from '@ai-content-hub/content-kit';
import {
    matchElementSchema,
    type MatchElementData,
    type MatchItem,
    type MatchOption,
    type MatchAnswer,
    normalizeMatchData,
    createDefaultItem,
    createDefaultOption,
    getItemText,
    getOptionText,
} from './schema';
import { MatchEdit } from './MatchEdit';
import { MatchPlayer } from './MatchPlayer';
import { matchGrader } from './grader';

// Export types
export {
    matchElementSchema,
    type MatchElementData,
    type MatchItem,
    type MatchOption,
    type MatchAnswer,
};

// Export helpers
export {
    normalizeMatchData,
    createDefaultItem,
    createDefaultOption,
    getItemText,
    getOptionText,
};

// Export components
export { MatchEdit };
export { MatchPlayer };
export { matchGrader };

export const matchElement: ElementDefinition<MatchElementData, MatchAnswer> = {
    schema: matchElementSchema,
    EditComponent: MatchEdit as any,
    PlayerComponent: MatchPlayer as any,
    grader: matchGrader,
    validator: {
        validate: matchGrader.validate!,
    },
};
